export default __webpack_public_path__ + "static/media/img1.963f699d.jpg";